import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoChip, DiscoSection, DiscoText } from "@disco-ui"

interface BrainSearchProcessingWarningProps {
  className?: string
}

function BrainSearchProcessingWarning({ className }: BrainSearchProcessingWarningProps) {
  const classes = useStyles()
  const brainSearchBot = useBrainSearchBot()!

  return (
    <DiscoSection
      groovyDepths={"insideCard"}
      className={`${classes.wrapper} ${className || ""}`}
    >
      <div className={classes.header}>
        <DiscoText variant={"body-md-700"} color={"text.primary"}>
          {"Processing media assets..."}
        </DiscoText>
        <DiscoChip label={"Visible to Admin Only"} color={"yellow"} />
      </div>
      <DiscoText variant={"body-sm"} color={"text.secondary"}>
        {`Media assets such as videos or PDF attachments are still being processed and aren't yet available to ${brainSearchBot.name}. This usually takes a few minutes. Anything else in the lesson description can be used by ${brainSearchBot.name} right away.`}
      </DiscoText>
    </DiscoSection>
  )
}

const useStyles = makeUseStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(4, 2),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
}))

export default BrainSearchProcessingWarning
